import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    templateUrl: './footer.component.html',
    selector: 'footer-bar'
})
export class FooterComponent extends AppComponentBase implements OnInit {

    releaseDate: string;
    terminalSettings: string;//usado no congresso

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.releaseDate = this.appSession.application ? this.appSession.application.releaseDate.format('YYYYMMDD') : '';
        this.terminalSettings = JSON.parse(localStorage.getItem('terminal-settings'));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer.component.ts